import { render } from "./Bustour_asso_jinair.vue?vue&type=template&id=db5a206e&scoped=true"
import script from "./Bustour_asso_jinair.vue?vue&type=script&lang=js"
export * from "./Bustour_asso_jinair.vue?vue&type=script&lang=js"

import "./Bustour_asso_jinair.vue?vue&type=style&index=0&id=db5a206e&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db5a206e"]])

export default __exports__